import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectAccounts: {
    defaultMessage: 'Select one or more accounts',
    id: 'ReportsAccountList.selectAccounts',
  },
  selectAccount: {
    defaultMessage: 'Select account',
    id: 'ReportsAccountList.selectAccount',
  },
  selectYourAccount: {
    defaultMessage: 'Select your account',
    id: 'ReportsAccountList.selectYourAccount',
  },
  selectYourAccountSubHeader: {
    defaultMessage: 'Select an account you would like to verify with {clientName}.',
    id: 'ReportsAccountList.selectYourAccountSubHeader',
  },
});
